export enum TenantStatus {
  Active = 1,
  Blocked = 2,
  Created = 5,
  Rejected = 6,
  PendingReactivation = 7
}

(TenantStatus as any).__typeName = 'TenantStatus';
